module.exports = __webpack_public_path__ + "resources/img/img_moai_protect_func.289c0ecaf822b624c8f619c6742ecf9a.png";